module.exports = __webpack_public_path__ + "assets/img/binding-2.9a1dd349.jpg";